
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hubungikami",
      function () {
        return require("private-next-pages/hubungikami/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hubungikami"])
      });
    }
  